const translations = {
    es: {
        "basic": "Básico",
        "advanced": "Avanzado",
        "server": "Red",
        "protocol": "Protocolo",
        "protocol.description": "Seleccionar el protocolo a utilizar. MQTT, MQTTS",
        "ip": "IP",
        "ip.description": "Ip del servidor MQTT ó url.",
        "port": "Puerto",
        "port.description": "Puerto del servidor MQTT. (1883, 8883)",
        "user": "Usuario",
        "user.description": "Usuario del servidor MQTT.",
        "pass": "Contraseña",
        "pass.description": "Contraseña del servidor MQTT.",
        "client": "Cliente",
        "client.description": "Cliente del servidor MQTT asignado.",
        "type_topic": "Tipo topic",
        "type_topic.description": "Topic al que afecta al servidor MQTT.",
        "topic": "Topic",
        "topic.description": "Topic del servidor MQTT.",
        "topic_data": "Topic de mediciones",
        "topic_data.description": "Topic de envio de mediciones del servidor MQTT.",
        "topic_alerts": "Topic de alertas",
        "topic_alerts.description": "Topic de envio de alertas del servidor MQTT.",
        "topic_control": "Topic de control",
        "topic_control.description": "Topic de recepcion de comandos de control del servidor MQTT.",
        "topic_admin": "Topic de admin",
        "topic_admin.description": "Topic de recepcion de comandos de admin del servidor MQTT.",
        "topic.choices.data": "Mediciones",
        "topic.choices.alerts": "Alertas",
        "topic.choices.control": "Control",
        "topic.choices.admin": "Admin",
        // -
        "create.title": "Crear configuración de MQTT",
        "create.title.basic": "Crear configuración de MQTT Básico",
        "create.title.advanced": "Crear configuración de MQTT Avanzado",
        "edit.title": "Editar configuración de MQTT",
        "edit.title.basic": "Editar configuración de MQTT Básico",
        "edit.title.advanced": "Editar configuración de MQTT Avanzado",
    },
    en: {
        "basic": "Basic",
        "advanced": "Advanced",
        "server": "Network",
        "protocol": "Protocol",
        "protocol.description": "Select the protocol to use. MQTT, MQTTS",
        "port": "Port",
        "port.description": "Port of the MQTT server. (1883, 8883)",
        "user": "User",
        "user.description": "User of the MQTT server.",
        "pass": "Password",
        "pass.description": "Password of the MQTT server.",
        "client": "Client",
        "client.description": "Client of the MQTT server assigned.",
        "topic": "Topic",
        "topic.description": "Topic to the MQTT server.",
        "topic_data": "Topic of measurements",
        "topic_data.description": "Topic of measurements sending to the MQTT server.",
        "topic_alerts": "Topic of alerts",
        "topic_alerts.description": "Topic of alerts sending to the MQTT server.",
        "topic_control": "Topic of control",
        "topic_control.description": "Topic of control receiving from the MQTT server.",
        "topic_admin": "Topic of admin",
        "topic_admin.description": "Topic of admin receiving from the MQTT server.",
        "topic.choices.data": "Measurements",
        "topic.choices.alerts": "Alerts",
        "topic.choices.control": "Control",
        "topic.choices.admin": "Admin",
        // -
        "create.title": "Create MQTT configuration",
        "create.title.basic": "Create MQTT basic configuration",
        "create.title.advanced": "Create MQTT advanced configuration",
        "edit.title": "Edit MQTT configuration",
        "edit.title.basic": "Edit MQTT basic configuration",
        "edit.title.advanced": "Edit MQTT advanced configuration",
    },
};

export default translations;
